import { useRef } from "react";

const EARLY_ENTRY_GUARD_MS = 5000;

/**
 * Returns `true` if the page was first mounted within
 * `EARLY_ENTRY_GUARD_MS` of `scheduledTime`. Prevents pre-loaded tabs
 * from getting an unfair head start at the unlock boundary — they're
 * asked to do a full browser refresh instead. Mirrors the guard in
 * `art_of_the_day-v2.tsx` line 32 + lines 1361–1372.
 *
 * `scheduledTime` is the ISO timestamp returned by the backend; `null`
 * disables the guard.
 */
export function useEarlyEntryGuard(scheduledTime: string | null | undefined): boolean {
  const pageLoadedAtRef = useRef<number>(Date.now());
  if (!scheduledTime) return false;
  const scheduledMs = new Date(scheduledTime).getTime();
  if (!Number.isFinite(scheduledMs)) return false;
  return scheduledMs - pageLoadedAtRef.current <= EARLY_ENTRY_GUARD_MS;
}
